<template>
  <section>
    <div class="row">
      <div
        id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 50%;">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Rescue Center Details</h4>
            <form class="form-sample" @submit="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input required type="text" v-model="name"></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group horizontal label="Phone">
                    <b-form-input required type="number" maxlength="10" v-model="phone"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Email">
                    <b-form-input required type="email" v-model="email"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="HTTP Link">
                    <b-form-input type="text" v-model="link"></b-form-input>
                  </b-form-group>

                  <!-- <p id="GFG_UP" style="font-size: 15px;  
                          font-weight: bold;"> 
    </p> 
     <p id="GFG_DOWN" style="color:green; 
                            font-size: 20px;  
                            font-weight: bold;"> 
     </p>
                  -->
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Address">
                    <b-form-textarea id="textarea5" v-model="address" rows="5"></b-form-textarea>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="State">
                    <b-form-input required type="text" v-model="state"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Comments">
                    <b-form-input required type="text" v-model="comment"></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <label for="exampleInputEmail1" style="font-size:20px!important">Please Edit Location</label>

              <div class="input-group-prepend">
                <br />
                <div class="col-md-6">
                  <input
                    name="lat"
                    type="text"
                    v-model="lat"
                    class="form-control"
                    placeholder="Please Enter Latitude"
                    required
                  />
                </div>
                <br />
                <div class="col-md-6">
                  <input
                    name="lon"
                    type="text"
                    v-model="lon"
                    ref="myLngField"
                    placeholder="Please Enter Longitude"
                    class="form-control"
                    required
                  />
                </div>
              </div>

              <br />

              <div id="myMap"></div>
              <br />
              <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
 

<script>
import axios from "axios";
export default {
  name: "edituser",
  props: ["id"],
  data: () => {
    return {
      email: "",
      address: "",
      link: "",
      loading: false,
      lat: null,
      lon: null,
      name: "",
      phone: "",
      state: "",
      comment: ""
    };
  },
  mounted: function() {
    this.getDetails();
    this.getListClick();
      // this.getList();

  },
 watch: {
    lat: function() {
        this.getListClick();
    },
    lon: function() {
        this.getListClick();
    }
  },
  methods: {
    resetForm() {
      this.username = "";
      this.name = "";
      this.password = "";
      this.phone = "";
      this.email = "";
      this.occupation = "";
      this.organization = "";
      this.error = "";
      this.file = null;
      this.image = null;
    },
    getDetails() {
      this.loading = true;
      var data1 = {};

      axios({
        method: "GET",
        url: "/rescue/get/?id=" + this.id
      })
        .then(response => {
          this.loading = false;
          this.isstat = response.data.status;
          if (response.data.status === true) {
            this.data = response.data.data;
            this.name = response.data.data.name;
            this.link = response.data.data.link;
            this.state = response.data.data.state;
            this.phone = response.data.data.phone;
            this.email = response.data.data.email;
            this.address = response.data.data.address;
            this.lat = response.data.data.location[1];
            this.lon = response.data.data.location[0];
            this.comment = response.data.data.comment;

       

            if (response.data.data.photo != null) this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
          //alert("Something went wrong");
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    //   getList() {
    //   var marker = 1;
    //   var vm = this;
    //   var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
    //   var options = {
    //     zoom: 4,
    //     center: centerOfMap,
    //     mapTypeId: google.maps.MapTypeId.ROADMAP,
    //     mapTypeControl: false
    //   };
    //   var map = new google.maps.Map(document.getElementById("myMap"), options);
    //   var latlngset = new google.maps.LatLng(this.lat, this.lon);

    //   marker = new google.maps.Marker({
    //     map: map,
    //     position: latlngset
    //   });

    //   marker.setPosition(latlngset);

    //   google.maps.event.addListener(map, "click", function(event) {
    //     //Get the marker's location.
    //     vm.markerLocation(marker);
    //   });
    // },

   getListClick() {
      var marker = 1;
      var vm = this;
      var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);
      var options = {
        zoom: 4,
        center: centerOfMap,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false
      };
      var map = new google.maps.Map(document.getElementById("myMap"), options);
      var latlngset = new google.maps.LatLng(this.lat, this.lon);

      marker = new google.maps.Marker({
        map: map,
        position: latlngset
      });

      marker.setPosition(latlngset);

      google.maps.event.addListener(map, "click", function(event) {
        this.click = true;
        var clickedLocation = event.latLng;

        if (marker == 1) {
          marker = new google.maps.Marker({
            position: clickedLocation,
            map: map,
            draggable: true
          });
          google.maps.event.addListener(marker, "dragend", function(event) {
            vm.markerLocation(marker);
          });
        } else {
          marker.setPosition(clickedLocation);
        }

        //Get the marker's location.
        vm.markerLocation(marker);
      });
    },
    markerLocation(marker) {
      var currentLocation = marker.getPosition();
      this.lat = currentLocation.lat(); //latitude
      this.lon = currentLocation.lng(); //longitude
    },
    onSubmit(evt) {
      evt.preventDefault();
      var add = {};
      // var el_up = document.getElementById("GFG_UP");
      // var el_down = document.getElementById("GFG_DOWN");
      // var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
      // var regex = new RegExp(expression);
      // var url = this.link;
      // el_up.innerHTML = "URL = '" + url + "'";
      add["address"] = this.address;
      add["email"] = this.email;
      add["link"] = this.link;
      add["lat"] = this.lat;
      add["lon"] = this.lon;
      add["name"] = this.name;
      add["state"] = this.phone;
      add["phone"] = this.phone;
      add["x-auth-token"] = localStorage.getItem("token");
      add["id"] = this.id;
      add[" comment"] = this.comment;

      axios({
        method: "post",
        url: "/rescue/edit",
        data: add
      })
        .then(response => {
          this.msg = response.data.msg;
          this.id = response.data._id;
          this.loading = "false";
          if (response.data.status === true) {
            this.loading = false;
            // this.resetForm();
            alert("Updated Successfully ");
            this.$router.push({ path: "/rescueCentersList" });
          }
          if (response.data.status === false) {
            this.loading = false;

            alert("Please try again");
          }
        })
        .catch(err => {
          this.loading = false;

          alert("Please try again");
        });
    }
  }
};
</script>

 <style>
#myMap {
  height: 400px !important;
  width: 100%;
}
</style>